export default __webpack_public_path__ + "static/media/step_F@2x.861e1d45.png";